"use client";

import { useMemo, useState } from "react";

import { WalletContext } from "@/lib/wallet/context";

import type { WalletState } from "@/lib/wallet/context";
import type { ReactNode } from "react";

const unavailable = () =>
  Promise.reject(new Error("Wallet connection is not available in the demo."));

/** The prototype's simulated wallet. Imports no wallet library. */
export function DemoWalletProvider({ children }: { children: ReactNode }) {
  const [connected, setConnected] = useState(false);

  const value = useMemo<WalletState>(
    () => ({
      connected,
      setConnected,
      evmAddress: null,
      solanaAddress: null,
      ethereum: null,
      solana: null,
      connectEvm: unavailable,
      addEvmNetwork: unavailable,
      connectSolana: unavailable,
      disconnect: () => setConnected(false),
      disconnectEvm: () => undefined,
    }),
    [connected]
  );
  return <WalletContext value={value}>{children}</WalletContext>;
}
